import { NgModule } from '@angular/core';
import { ProcessorService } from '@df/ng/processor.service';

@NgModule()
export class DfNgModule {
    constructor(processorService: ProcessorService) {}
}
